import { computed } from 'vue'
import { simakatraConfig } from '@/core/config'
import { useOverviewStore } from '../../stores/overview'

export function useIdleToMain() {
  const overviewStore = useOverviewStore()

  const debugging = computed(() => simakatraConfig.overview.idleToMain?.debugging ?? true)
  const timeout = computed(() => (simakatraConfig.overview.idleToMain?.timeoutSec ?? 5) * 1000)
  const isActivated = computed(() => overviewStore.isActivated)

  function doTimeout() {
    overviewStore.showSamudkoyContent()
  }

  return {
    debugging,
    timeout,
    isActivated,
    doTimeout,
  }
}
